<template>
    <div class="p-4 pb-0">
        <h5>Yeni Tedavi</h5>
        <hr>
        <div class="row">
            <div class="col-lg-4">
                <label for="medication-date" class="fw-semibold">Tedavi Tarihi: </label>
                <input type="text" class="form-control" v-model="newMedicationData.medication_date"
                    placeholder="Tedavi Tarihi">
            </div>
            <div class="col-lg-4">
                <label for="medication-name" class="fw-semibold">Tedavi Adı: </label>
                <input type="text" class="form-control" v-model="newMedicationData.name" placeholder=" Tedavi Adı">
            </div>
            <div class="col-lg-4">
                <label for="medication-description" class="fw-semibold">Açıklama: </label>
                <input type="text" class="form-control" v-model="newMedicationData.description" placeholder="Açıklama">
            </div>
        </div>
        <AddPrescription ref="prescriptionForm" :medicationId="newMedicationData.id" :warehouseId="warehouseId" />
        <div class="row">
            <div class="col-lg-12 d-flex justify-content-end mt-4">
                <button @click="$emit('close')" class="me-2 btn btn-lg btn-light-brand">Vazgeç</button>
                <button @click="postMedication()" class=" btn btn-lg
                                            btn-success">Kaydet</button>
            </div>
        </div>
        <hr>
    </div>
</template>
<script>
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
import AddPrescription from '@/components/animal/AddPrescription.vue';
export default {
    name: 'NewAnimalMedicationForm',
    components: {
        AddPrescription,
    },
    props: {
        animalId: {
            type: Number,
            required: true
        },
        warehouseId: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            newMedicationData: {
                medication_date: '',
                name: '',
                description: '',
                animal: this.animalId,
                medication_prescription: [],
            },
        }
    },
    methods: {
        async postMedication() {
            try {
                const payload = {
                    ...this.newMedicationData,
                    medication_date: dayjs(this.newMedicationData.medication_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                };
                this.newMedicationData = payload;
                this.newMedicationData.medication_prescription = this.$refs.prescriptionForm.prescriptionData;
                console.log('newMedicationData: ', this.newMedicationData);
                await this.$axios.post('medication/', this.newMedicationData);
                this.$emit('medication-added', this)
            } catch (error) {
                let errorMessage = Object.entries(error.response.data)
                    .map(([key, value]) => `${key}: ${value}`)
                    .join('<br><br>');

                Swal.fire({
                    title: 'Hata!',
                    html: errorMessage,
                    icon: 'error',
                    confirmButtonText: 'Tamam'
                });
            }
        },
    }
}
</script>